<div class="page">
  <div class="frame ">
    <!-- Backgrounds -->
    <div class="snowy-mountain-range"></div>
    <div class="floor-gradient"></div>

    <!-- Header -->
    <header class="header">
      <div class="header-left">
        <img class="logo" src="https://c.animaapp.com/mjb434uzIGc6TG/img/kga-bangalore-new-logo-1-1.png" alt="Logo" />
        <div class="header-text-group">
          <div class="heading-modules"> Modules </div>
          <!-- <div class="coords">48.4° N, 126.5° E</div> -->
          <!-- <div class="location">SEOUL, SK</div> -->
        </div>
      </div>

      <div class="header-center">
        <div class="time">{{ currentTime }}</div>
        <div class="date">{{ currentDate }}</div>
      </div>

      <div class="header-right">
        <div class="user-profile">
          <div>
            <img [src]="profileImage || '/noprofile.svg'" alt="User Avatar" class="avatar-small" />
          </div>
          <div class="profile-dropdown position-relative d-inline-block" (click)="toggleProfileDropdown($event)" [class.open]="isProfileOpen">
            <!-- Profile Info -->
            <div class="d-flex flex-column profile-box">
              <div class="profile-name">
                {{ userDetails?.adminUser?.name || '' }}
              </div>
              <div class="profile-role">
                {{ userDetails?.adminUser?.roles?.length > 0 ? userDetails?.adminUser?.roles[0]?.roleName : '' }}
              </div>
            </div>
            <!-- Visible dropdown icon -->
            <span class="dropdown-icon icon" aria-hidden="true">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                <path d="M6 9l6 6 6-6" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <!-- Dropdown -->
            <div class="logout-dropdown">
              <button class="logout-btn" (click)="logout()">Logout</button>
            </div>
          </div>
        </div>
      </div>
    </header>

    <!-- Main Modules Strip (horizontal scroll when cards overflow) -->
    <div class="modules-wrapper">
      <div class="modules-scroll" #modulesScroll>
        <div *ngFor="let module of moduleListAcess; let i = index" 
             class="card-group" 
             data-media-type="banani-button"
             (click)="navigateApp(module)">
          <div class="card-container">
            <div class="card-gradient" [ngClass]="getGradientClass(i)"></div>
            <div class="card-title" [innerHTML]="getCardTitle(module)"></div>
          </div>
          <img class="img-main" 
               [ngClass]="getImageClass(i)" 
               [src]="getMainImage(i)" 
               [alt]="module.moduleName" />
          <img class="img-reflection" 
               [ngClass]="getReflectionClass(i)" 
               [src]="getReflectionImage(i)"
               alt="Reflection" />
        </div>
      </div>
    </div>
  </div>
</div>